import { useQuery } from 'react-query';

import { getPdpRecommendIdList } from '../graphql/pdp_recommend_id_list.2';
import { GetPdpRecommendIdListVariables } from '../graphql/pdp_recommend_id_list_types.2';

const QUERY_KEY = 'getPdpRecommendIdList';

const fetchPdpRecommendIdList = async (params: GetPdpRecommendIdListVariables) => {
  const {
    data: { pdp_recommend_id_list },
  } = await getPdpRecommendIdList(params, { show_alert: false });
  return pdp_recommend_id_list;
};

interface Props {
  catalog_product_id: string;
  enabled: boolean;
}
export const usePdpRecommendIdList = ({ catalog_product_id, enabled }: Props) => {
  return useQuery({
    queryKey: [QUERY_KEY, catalog_product_id],
    queryFn: () =>
      fetchPdpRecommendIdList({
        catalog_product_id,
      }),
    enabled,
  });
};
